// frontend/src/features/equipment/EquipmentSetupWizard/components/ReviewListItem.tsx
import { Badge, Group, Paper, Text } from '@mantine/core';
import { SUBCATEGORIES } from '@/data/equipmentCatalogData';
import { getDisplayName } from '../utils/equipmentMapping';
import type { PendingEquipment } from '../types';

interface ReviewListItemProps {
  /** The equipment item to display */
  equipment: PendingEquipment;
}

/**
 * Displays a single equipment item in the review list.
 * Shows brand/model name, subcategory, and quantity (if > 1).
 */
export function ReviewListItem({ equipment }: ReviewListItemProps) {
  const displayName = getDisplayName(equipment.brandModel);
  const subcategory = SUBCATEGORIES.find((s) => s.id === equipment.subcategoryId);
  const subcategoryName = subcategory?.name || equipment.subcategoryId;

  return (
    <Paper
      p="xs"
      withBorder
      data-testid={`review-list-item-${equipment.tempId}`}
    >
      <Group justify="space-between" wrap="nowrap">
        <div style={{ minWidth: 0, flex: 1 }}>
          <Group gap="xs" wrap="nowrap">
            <Text fw={500} truncate>
              {displayName}
            </Text>
            {equipment.quantity > 1 && (
              <Badge size="sm" variant="light" color="blue">
                ×{equipment.quantity}
              </Badge>
            )}
          </Group>
          <Text size="sm" c="dimmed">
            {subcategoryName}
          </Text>
        </div>
      </Group>
    </Paper>
  );
}
